import React, { FC } from "react";
import styled from "styled-components";   
import { CustomLabel, FlexContainer, SapphireBlueButton } from "../styles";
import SingleSelect from "./SingleSelect";

type IProps = {
  icon: string;
  title: string;
  totalItems: number;
  description?: string;
  isShowHeaderButton?: boolean;
  showRecentButton?: boolean;
  disableButton?: boolean;
  onNewButtonClick?: () => void;
};

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .grid-icon {
      margin-right: 15px;
      height: 22px;
      width: 19px;
      margin-bottom: 4px;
      & + .orange-semi-bold {
          margin-left: 10px;
      }
  }
  .header-buttons {
      margin-bottom: 10px;
      button {
          width: 61px;
          height: 30px;
          padding: 0px 10px;
          min-width: 61px;
          font-size: 14px;
          font-weight: 600;
      }
  }
  .options-custom-dropdown {
      width: auto;
      min-width: 90px;
      /* max-width: 100px; */
      .header {
          border: none;
          width: auto;
          max-width: 100px;
          color: #556bb8;
          font-weight: 400;
          height: 36px;
          font-size: 14px;
          padding: 7px;
          padding-right: 0px;
          line-height: 24px;
          cursor: pointer;
          .select-header-icon {
              border-left: 0px;
              height: 30px;
          }
      }
      .options-menu {
          border: none;
          transform: translate(4px, 34px);
          li {
              font-size: 14px;
              cursor: pointer;
          }
      }
  }
`;

const TableWithHeaderButtons: FC<IProps> = ({
  title,
  icon,
  totalItems,
  isShowHeaderButton = false,
  onNewButtonClick,
  description,
  showRecentButton = true,
  disableButton = false,
}) => {
  return (
      <Header>
          {description && (
              <CustomLabel fontSize="14px" className="table-header-desc">
                  {description}
              </CustomLabel>
          )}
          {!description && (
              <CustomLabel fontSize="20px" fontWeight="600" margin="0px 0px 10px">
                  <img src={icon} className="grid-icon" />
                  {title}
                  <span className="orange-semi-bold">{totalItems}</span>
              </CustomLabel>
          )}
          {isShowHeaderButton && (
              <div className="header-buttons">
                  <FlexContainer spacing={30} alignItems="center">
                      {showRecentButton && (
                          <SingleSelect
                              selectedKey={'Recent'}
                              nameKeys={['label']}
                              valueKeys={['value']}
                              onChange={() => {}}
                              options={[[{ label: 'Recent', value: 'Recent' }]]}
                              searchable={false}
                              className="options-custom-dropdown"
                          />
                      )}
                      <SapphireBlueButton  disabled={disableButton} onClick={onNewButtonClick}>New</SapphireBlueButton>
                  </FlexContainer>
              </div>
          )}
      </Header>
  );
};

export default TableWithHeaderButtons;
